import BrandclubStoreConfigUtils from "./brandclubStoreConfigUtils.js";
const _Logger = class _Logger {
  constructor(context, stage = BrandclubStoreConfigUtils.getAppStage()) {
    this.context = context;
    this.logLevel = stage === "prod" ? _Logger.LOG_LEVELS.ERROR : stage === "localhost" ? _Logger.LOG_LEVELS.DEBUG : _Logger.LOG_LEVELS.INFO;
  }
  formatMessage(level, message, ...args) {
    const timestamp = (/* @__PURE__ */ new Date()).toISOString().split("T")[1].split(".")[0];
    const formattedMessage = `[${level}] [${timestamp}] [${this.context}] ${message}`;
    const consoleMethods = {
      // eslint-disable-next-line no-console
      "DEBUG": console.debug,
      // eslint-disable-next-line no-console
      "INFO": console.info,
      // eslint-disable-next-line no-console
      "WARN": console.warn,
      // eslint-disable-next-line no-console
      "ERROR": console.error
    };
    const consoleMethod = consoleMethods[level] || console.log;
    if (args.length > 0) {
      consoleMethod(formattedMessage, ...args);
    } else {
      consoleMethod(formattedMessage);
    }
  }
  debug(message, ...args) {
    if (this.logLevel <= _Logger.LOG_LEVELS.DEBUG) {
      this.formatMessage("DEBUG", message, ...args);
    }
  }
  info(message, ...args) {
    if (this.logLevel <= _Logger.LOG_LEVELS.INFO) {
      this.formatMessage("INFO", message, ...args);
    }
  }
  warn(message, ...args) {
    if (this.logLevel <= _Logger.LOG_LEVELS.WARN) {
      this.formatMessage("WARN", message, ...args);
    }
  }
  error(message, ...args) {
    if (this.logLevel <= _Logger.LOG_LEVELS.ERROR) {
      this.formatMessage("ERROR", message, ...args);
    }
  }
  setLogLevel(level) {
    this.logLevel = _Logger.LOG_LEVELS[level];
  }
};
_Logger.LOG_LEVELS = {
  DEBUG: 0,
  INFO: 1,
  WARN: 2,
  ERROR: 3,
  NONE: 4
};
let Logger = _Logger;
export {
  Logger
};
//# sourceMappingURL=logger.js.map
